import { METRIKA_ID } from "./config";

/**
 * The ONLY Yandex Metrika bridge on the site — one counter id, one `reachGoal`.
 * There used to be a second wrapper (`src/utils/analytics.ts`) with its own
 * copy of the counter id, so half the goals were reported without the A/B
 * variant tag below and a counter change had to be made in two places.
 *
 * `window.__lc_ab` is written by the SSR shell (server-side A/B assignment), so
 * every goal carries the variant it was earned under.
 */
export function reachGoal(goalId: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined" || typeof window.ym !== "function") return;
  const abVariants = (window as { __lc_ab?: Record<string, string> }).__lc_ab;
  const mergedParams = abVariants ? { ...params, ab_variant: abVariants } : params;
  window.ym(METRIKA_ID, "reachGoal", goalId, mergedParams);
}
